import React from "react";

export default function SpeedStack({ show, text, icon, style = {} }) {
	return (
		<div
			style={{
				width: 15,
				height: 31,
				marginTop: 5,
				boxSizing: "border-box",
				...style
			}}
		>
			<div
				style={{
					marginTop: 2,
					height: 10,
					lineHeight: "18px",
					fontSize: 10,
					color: "#fff",
					textAlign: "center"
				}}
			>
				{show ? text : ""}
			</div>

			<div
				style={{
					width: 18,
					height: 18,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					overflow: "hidden" // prevents oversized SVG from shifting layout
				}}
			>
				{icon}
			</div>
		</div>
	);
}
